import React, { useEffect, useImperativeHandle, useState } from 'react';
import { BaseImageConfig } from './BaseImageConfig';

// generated images regex: /.*(user[-_]generated|flux-images).*\.(webp|png|mp4)($|\?)/i;

/* eslint-disable react/jsx-props-no-spreading */
function BaseImage(
	{
		src = null,
		alt = '',
		loading = BaseImageConfig.defaultLoadingType,
		onError = (e) => {
			e.target.onerror = null; // prevents looping
		},
		style,
		onLoad,
		breakpoints = [],
		...props
	},
	imageRef,
) {
	const [isImageLoaded, setIsImageLoaded] = useState(false);
	const ref = React.useRef(null);

	useImperativeHandle(
		imageRef,
		() => ({
			getImage() {
				return ref.current;
			},
			complete: ref.current?.complete,
		}),
		[ref],
	);

	useEffect(() => {
		if (ref.current) {
			if (ref.current.complete) {
				setIsImageLoaded(true);
			} else if (!ref.current.complete) {
				setIsImageLoaded(false);
			}
		}
	}, [src]);

	const onImageLoadFinish = (e) => {
		setIsImageLoaded(true);
		if (typeof onLoad === 'function') onLoad(e);
	};

	const generateSrcSet = (imageSrc) => {
		if (breakpoints.length === 0) return '';
		return breakpoints.map((size) => `${imageSrc}?sizes=${size}&quality=100 ${size}w `).join(', ');
	};

	const generateSize = () => {
		if (breakpoints.length === 0) return '';
		return `(min-width: 0px) and (max-width: 600px) ${breakpoints[0]}px,(min-width: 601px) and (max-width: 1200px) ${breakpoints[1]}px,(min-width: 1201px) ${breakpoints[2]}px`;
	};

	return (
		<img
			ref={ref}
			style={{
				opacity: isImageLoaded || ref.current?.complete ? 1 : 0.4,
				transition: 'opacity 0.1s ease-in-out',
				...style,
			}}
			onLoad={onImageLoadFinish}
			src={src}
			srcSet={generateSrcSet(src)}
			alt={alt}
			loading={loading}
			onError={onError}
			sizes={generateSize()}
			{...props}
		/>
	);
}

/* eslint-enable react/jsx-props-no-spreading */
export default React.forwardRef(BaseImage);
